module.exports = __webpack_public_path__ + "img/idata-copropietarios-blanco.da3b78c3.svg";